import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e6aef80e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "signature-content input-flex-container" };
const _hoisted_2 = ["data-external"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 1,
    class: "signature-text view"
};
const _hoisted_5 = ["data-external"];
const _hoisted_6 = ["data-external"];
const _hoisted_7 = {
    key: 0,
    class: "sign-date",
    "data-external": "editor-view-signature-merge-tag-signing-date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass([
                'input-wrapper signature-input-wrapper',
                { 'hidden-signature': _ctx.signature.inputSettings.hide },
            ])
        }, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    'input-default-text input-default-signature signature-field',
                    {
                        'current-recipient-field': _ctx.getIsAssignedToCurrentUser(_ctx.signature) && !_ctx.getSignatureSvg,
                        'focused-field': _ctx.fieldHasFocus,
                    },
                    _ctx.getBorderStyle,
                ]),
                "data-external": `editor-view-signature-field-${_ctx.node.borderStyle}`,
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleClickSignField(_ctx.signature)))
            }, [
                (_ctx.getSignatureSvg)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "signature-image view",
                        alt: "signature-image",
                        src: _ctx.getSignatureSvg
                    }, null, 8, _hoisted_3))
                    : (!_ctx.isPdfViewer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.getSignatureFieldText(_ctx.signature)), 1))
                        : _createCommentVNode("", true),
                (_ctx.isLoadingSignature && _ctx.getIsAssignedToCurrentUser(_ctx.signature))
                    ? (_openBlock(), _createBlock(_component_FriedSpinner, {
                        key: 2,
                        class: "updating-spinner",
                        size: 20
                    }))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_2)), [
                [_directive_tooltip, _ctx.getTooltip(_ctx.signature)]
            ]),
            (_ctx.showMergeTagContainer)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['merge-tag-container view', _ctx.getAlign]),
                    "data-external": "editor-view-signature-merge-tag-container"
                }, [
                    _createElementVNode("div", {
                        "data-external": `editor-view-signature-merge-tags-container-alignment-${_ctx.node.align}`
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleMergeTags(_ctx.node.mergeTagsSettings), (tag, _index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: _index,
                                class: _normalizeClass(tag.key.toLowerCase()),
                                "data-external": `editor-view-signature-merge-tag-${tag.key}`
                            }, _toDisplayString(tag.value), 11, _hoisted_6));
                        }), 128)),
                        (_ctx.signDateSettings.show)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getSignDate), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_5)
                ], 2))
                : _createCommentVNode("", true)
        ], 2)
    ]));
}
